<p>Login OK!. Redirecting...</p>
<p>
  {{ message }}
</p>
